import { render, staticRenderFns } from "./StoperKeyboard.vue?vue&type=template&id=66554f34&scoped=true&"
import script from "./StoperKeyboard.vue?vue&type=script&lang=js&"
export * from "./StoperKeyboard.vue?vue&type=script&lang=js&"
import style0 from "./StoperKeyboard.vue?vue&type=style&index=0&id=66554f34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66554f34",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66554f34')) {
      api.createRecord('66554f34', component.options)
    } else {
      api.reload('66554f34', component.options)
    }
    module.hot.accept("./StoperKeyboard.vue?vue&type=template&id=66554f34&scoped=true&", function () {
      api.rerender('66554f34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/StoperKeyboard.vue"
export default component.exports